import {MutationTree} from 'vuex';
import {Branch, BranchInitState} from '@/store/branch/branch.types';

export const BranchMutations: MutationTree<BranchInitState> = {
  ['branchInit'](state: BranchInitState) {
    // state.loading = true
  },
  ['mutationGetBranch'](state: BranchInitState, payload: Branch[]) {
    state.branchs = payload;
  }
};
